import './App.css';
import Routes from './components/Routes';
import { HashRouter } from "react-router-dom"
import { AppContext } from './context/AppContext';
import Sidebar from './components/Sidebar';
import { useContext, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

function App() {
  const { login, appData } = useContext(AppContext);
  useEffect(() => {
    if (!localStorage.getItem("ipConfig")) {
      localStorage.setItem("ipConfig", window.location.origin);
      window.location.reload();
    }
  }, [])

  return (
    <div className="App">
      <div className="pageWrapper">
        <main>
          <div className="">
            <div className="row" style={{margin:"unset"}}>
              <HashRouter>
                {login.isLogin && <div className="col-xl-2 col-lg-3">
                  <Sidebar />
                </div>}
                {(() => {
                  const { isKeyDisabled, versionDetails } = appData;
                  const expiryDateStr = versionDetails?.expiryDate;
                  const warnDateStr = versionDetails?.warnDate;

                  const today = new Date();
                  const expiryDate = expiryDateStr ? new Date(expiryDateStr) : null;
                  const warnDate = warnDateStr ? new Date(warnDateStr) : null;

                  const isExpired = expiryDate && today > expiryDate;
                  const isWarning = warnDate && today >= warnDate && today <= expiryDate;
                  const isUpdateRequired = isKeyDisabled || isExpired;

                  // 🔴 Fully block access if version is expired or key is disabled or version mismatch
                  if (isUpdateRequired && login.isLogin) {
                    return (
                      <div className={login.isLogin ? "col-xl-10 col-lg-9" : ""}>
                        <span id="ferror" className="alert alert-danger p-1 mt-3 fw-semibold" role="alert">
                          Your app version has expired or is invalid. Please update to continue using the app.
                        </span>
                      </div>
                    );
                  }

                  // ⚠️ Show warning if in warning period but allow access
                  return (
                    <div className={login.isLogin ? "col-xl-10 col-lg-9" : ""}>
                      {(isWarning && login.isLogin) && (
                        <div>
                          <span id="ferror" className="alert alert-info p-1 mt-3 fw-semibold" role="alert">
                            Your app version will expire in {Math.ceil((expiryDate.getTime() - today.getTime()) / (1000 * 3600 * 24))} day{Math.ceil((expiryDate.getTime() - today.getTime()) / (1000 * 3600 * 24)) !== 1 ? 's' : ''}. Please update soon.
                          </span>
                        </div>
                      )}
                      <Routes />
                    </div>
                  );
                })()}
              </HashRouter>
            </div>
          </div>
        </main>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </div>
  );
}

export default App;
